import { useState } from "react";
import { motion } from "framer-motion";

/**
 * A still image from the org's content catalog, full-bleed. Videos are
 * iframes and pages are iframes; an image is the one kind the browser can
 * draw directly, so there is nothing to unlock and nothing to embed -- the
 * URL is used as-is, which is also why the console insists on https for this
 * kind: an http image on an https wall fails silently.
 */
export function ImageScreen({ url, title }: { url: string; title: string }) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="flex h-full w-full flex-col items-center justify-center gap-3 bg-ink text-center"
      >
        <span className="text-2xl font-bold text-fg" dir="auto">
          {title || "الصورة غير متوفرة"}
        </span>
        <span className="text-sm text-dim" dir="auto">
          تعذّر تحميل الصورة
        </span>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="h-full w-full bg-ink"
    >
      <img
        src={url}
        alt={title || "صورة"}
        onError={() => setFailed(true)}
        className="h-full w-full object-contain"
        dir="auto"
      />
    </motion.div>
  );
}
